export const findTargetElement = async (
  selector: string
): Promise<HTMLElement | null> => {
  // Arbitrary time between checks
  const timeBetweenChecks = 40;
  // Arbitrary max check duration
  const maxCheckDuration = 10000;

  let totalTimeoutDuration = 0;

  while (totalTimeoutDuration < maxCheckDuration) {
    const element = document.querySelector<HTMLElement>(selector);

    if (element !== null) {
      return element;
    }

    totalTimeoutDuration += timeBetweenChecks;

    await new Promise((resolve) => setTimeout(resolve, timeBetweenChecks));
  }

  return null;
};
